import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigConstants } from '../../config/config-constants';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';
import { InputFieldPropertiesInterface } from '../../interfaces/input-field-properties.interface';
import { InputFieldPropertyModel } from '../../models/low-level/input-field-property.model';
import { EventService } from '../event/event.service';
import { OdataInputFieldPropertiesService } from './odata-input-field-properties.service';

@Injectable({
    providedIn: 'root',
})
export class InputFieldPropertiesService implements InputFieldPropertiesInterface {
    public isInitialized = false;

    private models: InputFieldPropertyModel[] = [];
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly eventService: EventService,
        private readonly odataInputFieldPropertiesService: OdataInputFieldPropertiesService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {
        this.eventService.syncReceiveCompleted$.subscribe(() => this.init());
    }

    public init(): Observable<InputFieldPropertyModel[]> {
        return this.odataInputFieldPropertiesService.getInputFieldPropertySet().pipe(
            tap((models) => {
                this.models = models;
                this.isInitialized = true;
            }),
        );
    }

    /**
     * Get all properties of an input field defined by its name and the screen it is placed on
     *
     * @param fieldName
     * @param screenName
     * @param process
     */
    public getInputFieldProperties(
        fieldName: string,
        screenName: string,
        process: ConfigConstants.PROCESS_INDICATOR,
    ): InputFieldPropertyModel | undefined {
        if (!this.isInitialized) {
            throw new Error(
                `InputFieldPropertiesService: getInputFieldProperties: Trying to call InputFieldPropertiesService before initialization!`,
            );
        }

        const properties = this.models.filter((model) =>
            this.clientManager.isNgmP58()
                ? model.fieldName === fieldName && model.screenName === screenName && model.process === process
                : model.fieldName === fieldName && model.screenName === screenName,
        );
        let res: InputFieldPropertyModel | undefined;

        if (properties.length === 0) {
            this.log.warn(`FieldName '${fieldName}' and ScreenName '${screenName}' are not a valid identifier!`);
        } else if (properties.length > 1) {
            this.log.warn(`FieldName '${fieldName}' and ScreenName '${screenName}' are not a unique identifier!`);
        } else {
            res = properties[0];
        }

        return res;
    }
}
